export enum CompanyName {
    OWN_INVENTORY = 'meinestadt',
    IMMOWELT = 'immowelt',
}

export enum TypePaid {
    OWN_INVENTORY = 'standard',
    IMMOWELT = 'backfill',
}

export enum Variant {
    NEW = 'neu',
    DEFAULT = 'default',
}

export enum LikedAction {
    ADD = 'hinzufügen',
    REMOVE = 'entfernen',
}

export enum BookmarkListAction {
    REMOVE = 'entfernen',
    RESTORE = 'rückgängig',
}

export enum BookmarkListBodyType {
    BODY = 'body',
    TOAST = 'toast',
    STICKY = 'sticky',
}
